const BASE = process.env.REACT_APP_API_URL || '/api';

function getToken() {
  const user = JSON.parse(localStorage.getItem('flo_user') || '{}');
  return user.token || '';
}

function headers() {
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${getToken()}`,
  };
}

async function request(method, path, body) {
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers: headers(),
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Request failed');
  return data;
}

export const api = {
  // Auth
  signup:       (body) => request('POST', '/auth/signup', body),
  getCredits:      ()       => request('GET',  '/credits/balance'),
  createCheckout:  (body)   => request('POST', '/credits/checkout', body),
  deductCredits:   (body)   => request('POST', '/credits/deduct', body),
  login:          (body) => request('POST', '/auth/login', body),
  forgotPassword:  (body) => request('POST',  '/auth/forgot-password', body),
  resetPassword:   (body) => request('POST',  '/auth/reset-password', body),
  changePassword:  (body) => request('PATCH', '/auth/change-password', body),
  me:           ()     => request('GET',  '/auth/me'),
  saveSettings:    (body) => request('PUT',   '/auth/settings', body),
  updateSettings:  (body) => request('PATCH', '/auth/update-settings', body),

  // Leads
  getLeads:     (params = {}) => request('GET',    `/leads?${new URLSearchParams(params)}`),
  getLead:      (id)          => request('GET',    `/leads/${id}`),
  createLead:   (body)        => request('POST',   '/leads', body),
  updateLead:   (id, body)    => request('PUT',    `/leads/${id}`, body),
  updateStatus: (id, body)    => request('PATCH',  `/leads/${id}/status`, body),
  deleteLead:   (id)          => request('DELETE', `/leads/${id}`),
  toggleLeadAI: (id, body)    => request('PATCH',  `/leads/${id}/ai-toggle`, body),
  massText:     (body)        => request('POST',   '/leads/mass-text', body),

  // Conversations
  getConversation: (leadId)        => request('GET',  `/conversations/${leadId}`),
  sendMessage:     (leadId, body)  => request('POST', `/conversations/${leadId}`, body),
  getInbox:        ()              => request('GET',  '/conversations'),

  // Appointments
  getAppointments:   ()         => request('GET',    '/appointments'),
  createAppointment: (body)     => request('POST',   '/appointments', body),
  updateAppointment: (id, body) => request('PUT',    `/appointments/${id}`, body),
  cancelAppointment: (id)       => request('DELETE', `/appointments/${id}`),

  // Policies
  getPolicies:  ()     => request('GET',  '/policies'),
  createPolicy: (body) => request('POST', '/policies', body),

  // Analytics
  getAnalytics: () => request('GET', '/analytics'),

  // AI
  enrichLead:       (body) => request('POST', '/ai/enrich', body),
  generateOutbound: (body) => request('POST', '/ai/outbound', body),
  handleReply:      (body) => request('POST', '/ai/reply', body),
  bookAppointment:  (body) => request('POST', '/ai/appointment', body),

  // SMS
  sendSMS: (body) => request('POST', '/sms/send', body),

  // Scraping
  runScrape:          (body) => request('POST', '/scrape/run', body),
  getScrapeSettings:  ()     => request('GET',  '/scrape/settings'),
  saveScrapeSettings: (body) => request('POST', '/scrape/settings', body),

  // Billing
  createSubscriptionCheckout: (body) => request('POST', '/billing/checkout', body),
  getSubscription: ()     => request('GET',  '/billing/subscription'),

  // Email
  sendAppointmentConfirmation: (body) => request('POST', '/email/appointment-confirmation', body),
  sendPolicyBreakdown:         (body) => request('POST', '/email/policy-breakdown', body),
  sendWelcomeEmail:            (body) => request('POST', '/email/welcome', body),
  testEmail:                   ()     => request('POST', '/email/test', {}),

  // Automation (autonomous conversation engine)
  startOutreach:    (leadId) => request('POST', `/automation/outreach/${leadId}`, {}),
  sendAutoReply:    (body)   => request('POST', '/automation/reply', body),
  runFollowUps:     ()       => request('POST', '/automation/followup', {}),
  getAutoStatus:    ()       => request('GET',  '/automation/status'),

  // Admin
  getAdminStats:       ()         => request('GET',    '/admin/stats'),
  getAdminSubscribers: ()         => request('GET',    '/admin/subscribers'),
  updateSubscriber:    (id, body) => request('PATCH',  `/admin/subscribers/${id}`, body),
  deleteSubscriber:    (id)       => request('DELETE', `/admin/subscribers/${id}`),

  // CSV Upload
  uploadLeads: (formData) => {
    const token = JSON.parse(localStorage.getItem('flo_user') || '{}').token;
    return fetch('/api/upload/leads', { method: 'POST', headers: { 'Authorization': 'Bearer ' + token }, body: formData })
      .then(r => {
        if (!r.ok) throw new Error(`Upload failed: ${r.status} ${r.statusText}`);
        return r.json();
      });
  },

  // 24/7 Engine
  startEngine:    ()         => request('POST',   '/engine/start', {}),
  stopEngine:     ()         => request('POST',   '/engine/stop', {}),
  getEngineStatus:()         => request('GET',    '/engine/status'),
  saveEngineSettings:(body)  => request('POST',   '/engine/settings', body),

  // Templates
  getTemplates:  () => request('GET', '/templates'),
  saveTemplate:  (body) => request('POST', '/templates', body),

  // Workflows
  getWorkflows:   ()         => request('GET',    '/workflows'),
  createWorkflow: (body)     => request('POST',   '/workflows', body),
  updateWorkflow: (id, body) => request('PUT',    `/workflows/${id}`, body),
  deleteWorkflow: (id)       => request('DELETE', `/workflows/${id}`),
  deleteTemplate: (id)       => request('DELETE', `/templates/${id}`),
};

